export enum LoginAction {
  MAGIC_LINK = 'magic-link',
  EMAIL_CONFIRMATION = 'email-confirmation',
  DIRECT_LOGIN = 'direct-login',
  PLUS_ONE_SIGNUP = 'plus-one-signup',
  SSO_LOGIN = 'sso-login',
  REGISTRATION = 'registration',
}
